import React from 'react'

import { useCompletedVehiclesQuery, CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import { BasicWidgetProps } from '../../types'

const CompletedVehicles = ({ config, widgetId, handleConfig, readonly }: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useCompletedVehiclesQuery({
        variables: { searchString: 'status:sold,exited,redeemed,returned' },
    })

    const count = data?.auction?.search?.vehicleCount || 0

    return (
        <SingleNumberWidget
            cardType={CardType.VEHICLE}
            action={{
                text: 'View Vehicles',
                link: `/searchdetails/vehicle-ci?search=status:sold,exited,redeemed,returned`,
            }}
            number={count}
            text="Sold / Exited / Redeemed / Returned"
            secondaryText="Total"
            loading={loading}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default CompletedVehicles
